<template>
  <div id="PCurve">
    <dv-border-box-8>
      <div id="barsh1" style="height:90%"></div>
    </dv-border-box-8>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
export default {
  name: 'PCurve',
  data() {
    return {};
  },
  created() {},
  mounted() {
    var myChart1 = echarts.init(document.getElementById('barsh1'));

    var option = {
      title: {
        text: '变压器功率曲线',
        textStyle: {
          color: '#fff'
        }
      },
      grid: {
        left: '6%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      xAxis: [
        {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisTick: {
            alignWithLabel: true,
            interval: 0
          },
          axisLabel: {
            interval: 0,
            color: '#7f8fa4'
          },
          axisLine: {
            // 轴线
            lineStyle: {
              color: '#7f8fa4'
            }
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          boundaryGap: [0, '10%'],
          axisLabel: {
            color: '#7f8fa4'
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#7f8fa4'
            }
          }
        }
      ],
      series: [
        {
          name: 'Step Start',
          type: 'line',
          step: 'start',
          data: [120, 132, 101, 134, 90, 230, 210]
        },
        {
          name: 'Step Middle',
          type: 'line',
          step: 'middle',
          data: [220, 282, 201, 234, 290, 430, 410]
        },
        {
          name: 'Step End',
          type: 'line',
          step: 'end',
          data: [450, 432, 401, 454, 590, 530, 510]
        }
      ]
    };
    myChart1.setOption(option);
  },
  methods: {
    goto() {
      this.$router.push('/bscpage1');
    },
    thecolor(params) {
      var colorList = '';
      if (params.dataIndex > 5) {
        colorList = ' #a5a5a5';
      } else {
        colorList = '#009a1c';
      }

      if (params.dataIndex === 0) {
        if (this.legendColor) {
          return '#009a1c'; // 第二次params.dataIndex为0 的情况表示刷新图例的颜色
        } else {
          this.legendColor = true; // 第一次params.dataIndex为0 的情况
        }
      }

      return colorList;
    }
  }
};
</script>
<style lang="less">
#PCurve {
  position: relative;
  width: 95%;
  height: 50%;
  background-color: rgba(6, 30, 93, 0.5);
  //  border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
}
</style>
